import { serviceHandler } from '../service-executor';

const INVOICE_URL = '/api/otr/invoices';

export const search = (invoiceStatus, params, page, pageSize) => {
  const URL = `${INVOICE_URL}/all?paymentStatus=${invoiceStatus}&page=${page}&pageSize=${pageSize}`;
  return serviceHandler(URL, 'POST', params);
};

export const list = (invoiceStatus, params, page, pageSize) => {
  const URL = `${INVOICE_URL}/${invoiceStatus}?page=${page}&pageSize=${pageSize}`;
  return serviceHandler(URL, 'POST', params);
};

export const save = invoice => {
  const URL = `${INVOICE_URL}/save`;
  return serviceHandler(URL, 'POST', invoice);
};

export const update = invoice => {
  const URL = `${INVOICE_URL}/update`;  
  return serviceHandler(URL, 'POST', invoice);
};

export const getInvoiceById = (invoiceId) => {
  const URL = `${INVOICE_URL}/${invoiceId}`;
  return serviceHandler(URL, 'GET');
};

export const viewInvoiceReport = (orderIds, reportDate) => {
  let idList = `${orderIds[0]}`;
  orderIds.forEach((id, idx) => {
    if (idx !== 0)
      idList += `,${id}`;
  });
  const URL = `${INVOICE_URL}/${idList}/report?reportDate=${reportDate}`;
  return serviceHandler(URL, 'GET_BLOB');
};

export const generateInvoice = (invoiceIdList) => {
  let idList = `${invoiceIdList[0]}`;
  invoiceIdList.forEach((id, idx) => {
    if (idx !== 0)
      idList += `,${id}`;
  });
  const URL = `${INVOICE_URL}/${idList}/generate`;
  return serviceHandler(URL, 'GET');
};

export const unInvoice = (invoiceIdList) => {
  let idList = `${invoiceIdList[0]}`;
  invoiceIdList.forEach((id, idx) => {
    if (idx !== 0)
      idList += `,${id}`;
  });
  const URL = `${INVOICE_URL}/${idList}/uninvoice`;
  return serviceHandler(URL, 'GET');
};

export const processInvoicePayment = (payment) => {
  const URL = `${INVOICE_URL}/pay`;
  return serviceHandler(URL, 'POST', payment);
};

export const saveCheck = (invoiceId, check) => {
  const URL = `${INVOICE_URL}/${invoiceId}/check/save`;
  return serviceHandler(URL, 'POST', check);
};

export const viewFactoringInvoice = (orderIds) => {
  let idList = `${orderIds[0]}`;
  orderIds.forEach((id, idx) => {
    if (idx !== 0)
      idList += `,${id}`;
  });
  const URL = `${INVOICE_URL}/${idList}/factoring/preview`;
  return URL;
};

export const printFactoringInvoice = (orderIds) => {
  let idList = `${orderIds[0]}`;
  orderIds.forEach((id, idx) => {
    if (idx !== 0)
      idList += `,${id}`;
  });
  const URL = `${INVOICE_URL}/${idList}/factoring/printed`;
  return serviceHandler(URL, 'GET_BLOB');
};

export const getCountsByStatus = (status) => {
  const URL = `${INVOICE_URL}/status/${status}`;
  return serviceHandler(URL, 'GET');
};

export const getInvoiceCounts = () => {
  const URL = `${INVOICE_URL}/counts`;
  return serviceHandler(URL, 'GET');
};